var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScatterPlot24PxTwoTone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "scatter_plot_24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Light Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    opacity: 0.5,
    d: "M11 8C12.1046 8 13 7.10457 13 6C13 4.89543 12.1046 4 11 4C9.89543 4 9 4.89543 9 6C9 7.10457 9.89543 8 11 8Z",
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Light Color_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    opacity: 0.5,
    d: "M16.6016 19.6001C17.7061 19.6001 18.6016 18.7047 18.6016 17.6001C18.6016 16.4955 17.7061 15.6001 16.6016 15.6001C15.497 15.6001 14.6016 16.4955 14.6016 17.6001C14.6016 18.7047 15.497 19.6001 16.6016 19.6001Z",
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Light Color_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_3",
    opacity: 0.5,
    d: "M7 16C8.10457 16 9 15.1046 9 14C9 12.8954 8.10457 12 7 12C5.89543 12 5 12.8954 5 14C5 15.1046 5.89543 16 7 16Z",
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Dark Color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 14C3 11.79 4.79 10 7 10C9.21 10 11 11.79 11 14C11 16.21 9.21 18 7 18C4.79 18 3 16.21 3 14ZM5 14C5 15.1 5.9 16 7 16C8.1 16 9 15.1 9 14C9 12.9 8.1 12 7 12C5.9 12 5 12.9 5 14Z",
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Dark Color_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2C13.21 2 15 3.79 15 6C15 8.21 13.21 10 11 10C8.79 10 7 8.21 7 6C7 3.79 8.79 2 11 2ZM9 6C9 7.1 9.9 8 11 8C12.1 8 13 7.1 13 6C13 4.9 12.1 4 11 4C9.9 4 9 4.9 9 6Z",
    fill: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Dark Color_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6016 17.6001C12.6016 15.3901 14.3916 13.6001 16.6016 13.6001C18.8116 13.6001 20.6016 15.3901 20.6016 17.6001C20.6016 19.8101 18.8116 21.6001 16.6016 21.6001C14.3916 21.6001 12.6016 19.8101 12.6016 17.6001ZM14.6016 17.6001C14.6016 18.7001 15.5016 19.6001 16.6016 19.6001C17.7016 19.6001 18.6016 18.7001 18.6016 17.6001C18.6016 16.5001 17.7016 15.6001 16.6016 15.6001C15.5016 15.6001 14.6016 16.5001 14.6016 17.6001Z",
    fill: "#E0E0E0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScatterPlot24PxTwoTone);
export default __webpack_public_path__ + "static/media/scatter_plot_24px_two_tone.b0d0451edfa877df547abe4b2f270d5c.svg";
export { ForwardRef as ReactComponent };